import * as React from 'react'
// components
import { components, SingleValueProps } from 'react-select'
import { OpenRiskLink } from 'components/FormElements/components/OpenRiskLink'
// constants
import { ENTITIES } from 'constants/entities'
// types
import { IOption } from 'components/FormElements/Select'

const OpenRiskSingleValue: React.FC<SingleValueProps<IOption, boolean>> = (props) => {
  const { data, children } = props

  const isRisk = data.entity === ENTITIES.RISK && !!data.riskTemplateId

  if (!isRisk) {
    return <components.SingleValue {...props} />
  }

  return (
    <components.SingleValue {...props}>
      <OpenRiskLink riskId={data.value} riskTemplateId={data.riskTemplateId}>
        {children}
      </OpenRiskLink>
    </components.SingleValue>
  )
}

export default OpenRiskSingleValue
